export type TextMatchTier = 0 | 1 | 2 | 3;

export function alphanumericOnly(s: string): string {
    return s.replace(/[^\p{L}\p{N}]+/gu, "");
}

/** 0 = exact, 3 = loosest. Expects both arguments trimmed and lower-cased. */
export function getTextMatchTier(fieldValue: string, query: string): TextMatchTier | null {
    if (!fieldValue || !query) return null;
    const a = alphanumericOnly(fieldValue);
    const q = alphanumericOnly(query);
    if (a === "" || q === "") return null;
    if (fieldValue === query) return 0;
    if (a === q) return 1;
    if (fieldValue.startsWith(query)) return 1;
    if (fieldValue.includes(query)) return 2;
    if (a.includes(q)) return 3;
    return null;
}
